import { PhotoDTO } from '../dtoTypes'
import { Photo } from '../types'

export const adaptPhotoDTO = (photoDTO: PhotoDTO): Photo => {
    return {
        hashName: photoDTO.hash_name,
        readUrl: photoDTO.read_url,
    }
}
